import { JSONSerializable } from '../../util/json';
import { Coin } from '../Coin';
import { Dec, Numeric } from '../numeric';

export class PolicyConstraints extends JSONSerializable<
  PolicyConstraints.Data
> {
  public rate_min: Dec;
  public rate_max: Dec;
  public change_max: Dec;

  constructor(
    rate_min: Numeric.Input,
    rate_max: Numeric.Input,
    public cap: Coin,
    change_max: Numeric.Input
  ) {
    super();
    this.rate_min = new Dec(rate_min);
    this.rate_max = new Dec(rate_max);
    this.change_max = new Dec(change_max);
  }

  public static fromData(data: PolicyConstraints.Data): PolicyConstraints {
    const { rate_min, rate_max, cap, change_max } = data;
    return new PolicyConstraints(
      rate_min,
      rate_max,
      Coin.fromData(cap),
      change_max
    );
  }

  public toData(): PolicyConstraints.Data {
    const { rate_min, rate_max, cap, change_max } = this;
    return {
      rate_min: rate_min.toString(),
      rate_max: rate_max.toString(),
      cap: cap.toData(),
      change_max: change_max.toString(),
    };
  }

  public clamp(prevRate: Numeric.Input, newRate: Numeric.Input): Dec {
    const p: Dec = new Dec(prevRate); // prev
    let n: Dec = new Dec(newRate); // new

    if (n.lt(this.rate_min)) {
      n = this.rate_min;
    } else if (n.gt(this.rate_max)) {
      n = this.rate_max;
    }

    const delta: Dec = n.sub(p);
    if (n.gt(p)) {
      if (delta.gt(this.change_max)) {
        n = p.add(this.change_max);
      }
    } else {
      if (delta.abs().gt(this.change_max)) {
        n = p.sub(this.change_max);
      }
    }
    return n;
  }
}

export namespace PolicyConstraints {
  export interface Data {
    rate_min: string;
    rate_max: string;
    cap: Coin.Data;
    change_max: string;
  }
}
